export type CallEventType = 'answered' | 'unanswered' | 'rejected' | 'canceled';

/**
 * Create entries in chat about call status
 */
export class ChatCallNotifierService {
    static $inject = ['$http'];

    constructor(private $http: ng.IHttpService) {}

    public onCallStarted(meetingId: number) {
        return this.$http.post('/api/v2.0/chat/call-events/', {
            meeting: meetingId,
            content: {
                event_type: 'started',
            },
        });
    }

    public onCallAnswered(callEventId: number) {
        return this.updateCallEvent(callEventId, 'answered');
    }

    public onCallUnanswered(callEventId: number) {
        return this.updateCallEvent(callEventId, 'unanswered');
    }

    public onCallRejected(callEventId: number) {
        return this.updateCallEvent(callEventId, 'rejected');
    }

    public onCallCanceled(callEventId: number) {
        return this.updateCallEvent(callEventId, 'canceled');
    }

    private updateCallEvent(callEventId: number, type: CallEventType) {
        return this.$http.put(`/api/v2.0/chat/call-events/${callEventId}/`, {
            content: {
                event_type: type,
            },
        });
    }
}

angular.module('tradersyard').service('ChatCallNotifierService', ChatCallNotifierService);
